/*
 * Copyright (c) 2024 Cozy Intellect Inc.
 */

import { writable } from 'svelte/store';
export const aiPhoto = 'http://localhost:3000/avatars/avatar-1.png';
interface Person {
  name: string;
  href: string;
}
interface Tag {
  name: string;
  color: string;
  href: string;
}

export interface Message {
  id: number;
  type: 'comment';
  person: Person;
  role: 'system' | 'assistant' | 'user';
  imageUrl: string;
  comment: string;
  verb?: string;
  date: string;
  html?: string;
  assigned?: Person;
  tags?: Tag[];
}

interface Messages {
  list: Message[];
  lastId: number;
}

const today = new Date();
const timezone = (() => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch (error) {
    console.warn('Failed to get timezone from Intl.DateTimeFormat, using UTC as fallback:', error);
    return 'UTC';
  }
})();

export const messages = writable<Messages>({
  list: [
    {
      id: 0,
      type: 'comment',
      person: { name: 'system', href: '#' },
      role: 'system',
      imageUrl: aiPhoto,
      comment: `You are a career mentor that is guiding a new user through an onboarding flow.
            Your task is to access their goals, calendar events, and tasks using function calls to retrieve and analyze them.
            Do not ask the user for their goals before accessing them through the function call.
            The current time is ${today.toISOString()}. Please communicate in the user's local timezone, ${timezone}.
            `,
      date: '1d ago'
    },
    {
      id: 1,
      type: 'comment',
      person: { name: 'Retain', href: '#' },
      role: 'assistant',
      imageUrl: aiPhoto,
      comment: `I'm here to support you in your role. How can I help?`,
      date: '1d ago'
    }
  ],
  lastId: 1
});
